import request from '@/api/index'
/**
 * 1,首页
 */
 let userQZ = '/api'  // 线上
//  let userQZ = 'http://192.168.10.24:8180' // 本地
// 文件、图片-查询
export function fileRecord (data) {
    return request({
        url: userQZ + '/open/fileRecord/queryByCode', 
        method: 'get',
        params: data
      })
}
//文件、图片-修改
export function updateImg (data) {
  return request({
      url: userQZ + '/siteMaintain/fileRecord/update',
      method: 'post',
      data: data
    })
}
/**
 * 2,关于我们
 */
// 查询企业简介
export function getEntBrief (data) {
  return request({
      url: userQZ + '/open/getEntBrief',
      method: 'get',
      params:data
    })
}
// 企业简介-修改
 export function updateEntBrief (data) {
  return request({
      url: userQZ + '/siteMaintain/updateEntBrief',
      method: 'post',
      data: data
    })
}
// 查询企业文化
export function getEntCulture (data) {
  return request({
      url: userQZ + '/open/getEntCulture',
      method: 'get',
      params:data
    })
}
// 企业文化-修改
export function updateEntCulture (data) {
  return request({
      url: userQZ + '/siteMaintain/updateEntCulture',
      method: 'post',
      data: data
    })
}
// 资质荣誉-分页查询
export function certHonorPage (data) {
  return request({
      url: userQZ + '/open/certHonorPage',
      method: 'get',
      params: data
    })
}
// 资质荣誉-新增
export function createCertHonor (data) {
  return request({
      url: userQZ + '/siteMaintain/createCertHonor',
      method: 'post',
      data: data
    })
}
// 资质荣誉-修改
export function updateCertHonor (data) {
  return request({
      url: userQZ + '/siteMaintain/updateCertHonor',
      method: 'post',
      data: data
    })
}
// 资质荣誉-id查询
export function queryByIdCertHonor (data) {
  return request({
      url: userQZ + '/open/certHonor/queryById',
      method: 'get',
      params: data
    })
}
// 资质荣誉-删除
export function delCertHonor (data) {
  return request({
      url: userQZ + '/siteMaintain/delCertHonor',
      method: 'post',
      data: data
    })
}

/**
 * 3-主营业务
 */
// 主营业务-分页查询
export function PageMainBusiness (data) {
  return request({
      url: userQZ + '/open/mainBusiness/showPage',
      method: 'get',
      params: data
    })
}
// 主营业务-id查询
export function queryByIdMainBusiness (data) {
  return request({
      url: userQZ + '/open/mainBusiness/queryById',
      method: 'get',
      params: data
    })
}
// 主营业务-新增
export function CreateainBusiness (data) {
  return request({
      url: userQZ + '/siteMaintain/mainBusiness/create',
      method: 'post',
      data: data
    })
}
// 主营业务-修改
export function UpdateBusiness (data) {
  return request({
      url: userQZ + '/siteMaintain/mainBusiness/update',
      method: 'post',
      data: data
    })
}
// 主营业务-删除
export function DelBusiness (data) {
  return request({
      url: userQZ + '/siteMaintain/mainBusiness/del',
      method: 'post',
      data: data
    })
}

/**
 * 4-新闻动态
 */
// 新闻列表-分页查询
 export function PageNews (data) {
  return request({
      url: userQZ + '/open/news/newsPage',
      method: 'get',
      params: data
    })
}
// 新闻列表-id查询
export function queryByIdNews (data) {
  return request({
      url: userQZ + '/open/news/queryById',
      method: 'get',
      params: data
    })
}
// 新闻列表-新增
export function createlNews (data) {
  return request({
      url: userQZ + '/siteMaintain/news/create',
      method: 'post',
      data: data
    })
}
// 新闻列表-修改
export function UpdateNews (data) {
  return request({
      url: userQZ + '/siteMaintain/news/update',
      method: 'post',
      data: data
    })
}
// 新闻列表-删除
export function DelNews (data, id) {
  return request({
      url: userQZ + '/siteMaintain/news/del?newsId='+id,
      method: 'post',
      data: data
    })
}
/**
 * 5- 人力资源
 */
// 人力资源-分页查询
export function PageHrRecord (data) {
  return request({
      url: userQZ + '/open/hrRecord/query',
      method: 'get',
      params: data
    })
}
// 人力资源-id查询
export function queryByIdHrRecord (data) {
  return request({
      url: userQZ + '/open/hrRecord/queryById',
      method: 'get',
      params: data
    })
}
// 人力资源-新增
export function createHrRecord (data) {
  return request({
      url: userQZ + '/siteMaintain/hrRecord/create',
      method: 'post',
      data: data
    })
}
// 人力资源-修改
export function updateHrRecord (data) {
  return request({
      url: userQZ + '/siteMaintain/hrRecord/update',
      method: 'post',
      data: data
    })
}
// 人力资源-删除
export function delHrRecord (data) {
  return request({
      url: userQZ + '/siteMaintain/hrRecord/del',
      method: 'post',
      data: data
    })
}
/**
 * 主营业务
 */
//主营业务  - 查询
export function primaryBusiness (data) {
  return request({
      url: userQZ + '/open/primaryBusiness/'+data,
      method: 'get',
    })
}
//主营业务  - 修改
export function editPrimaryBusiness (data,code) {
  return request({
      url: userQZ + '/siteMaintain/primaryBusiness/'+code,
      method: 'post',
      data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/apiAll.js